import 'angular:locale/data:en-US';(globalThis.$localize ??= {}).locale = "en-US";
